<template>
	<div data-component="link-field">
		<v2-button
			type="text"
			fit
			data-element="copy-button"
			:variant="getExpired ? 'red' : 'filled'"
			:disabled="!getLinkUrl || getExpired"
			@click="copyLink">
			{{ getExpired ? 'Expired' : 'Copy' }}
			<icon v-if="!getExpired" icon="v2-copy" colour="transparent" />
		</v2-button>
		<input-field
			name="Deal link"
			type="text"
			:showLabel="false"
			readonly
			v-model="getLinkUrl"
		/>
	</div>
</template>

<script>

	import InputField from '@/components/forms/InputField.vue';
	import V2Button from '@/components/v2/ui/V2Button.vue';
	import Icon from '@/components/ui/Icon.vue';

	export default {
		components: {
			InputField,
			V2Button,
			Icon
		},
		props: {
			link: {
				type: Object,
				required: true
			}
		},
		data: () => {
			return {};
		},
		computed: {
			getLinkUrl () {
				if (this.link) {
					return `${process.env.VUE_APP_HANDLE_URL}/deal/${this.link?.token}`;
				}
				return null;
			},
			getExpired () {
				const expirationDate = this.link?.expirationDate;
				if (!expirationDate) {
					return false;
				}
				return this.$store.getters['auth/getTimeIsPast']({
					time: expirationDate
				});
			}
		},
		methods: {
			async copyLink () {
				if (this.getLinkUrl) {
					await navigator.clipboard?.writeText(this.getLinkUrl);
					this.$store.commit('ui/showNotification', {
						notification: 'Successfully copied'
					});
				}
			}
		}
	};

</script>

<style lang="scss" scoped>
	[data-component='link-field'] {
		width: 100%;
		display: flex;
		align-items: center;
		gap: 12px;

		[data-component='icon'] {
			margin-left: 6px;
		}

		[data-component='input-field'] {
			width: 100%;
		}
	}
</style>
